const info = require('./info')

const getRatePrice = ({
  rate,
  isTimeBased,
  amount,
}) => {
  // the normalize to days coefficient for the rate amount
  const rateAmountCoefficient = isTimeBased ?
    info.getTimeUnitDays(rate.unit) :
    1

  // the threshold amount for the rate to apply - normalized to days
  // rate.amount = 2, rate.unit = week, coeff = 5, threshold = 10
  // rate.amount = 8, rate.unit = hour, coeff = 1/8, threshold = 1
  // rate.amount = 3, rate.unit = day, coeff = 1, threshold = 3
  const rateThreshold = rateAmountCoefficient * (rate.amount || 1)

  // get the price of a single unit for the rate
  // this converts rates that have priceType=total into their unit prices
  // amount=10, price=10, priceType=total = 1
  // amount=10, price=1, priceType=unit = 1
  const rateUnitPrice = info.rateUnitPrice(rate)
  const rateTotalPrice = info.rateTotalPrice(rate)

  // the rateUnitPrice is per hour or week - we need it in days
  // rate.unit = week, coeff = 5, unitPrice = 100 - day price = 20
  // rate.unit = hour, coeff = 1/8, unitPrice = 10 - day price = 80
  // rate.unit = day, coeff = 1, unitPrice = 10 - day price = 10
  const normalizedRateUnitPrice = rateUnitPrice / rateAmountCoefficient

  // now we have the rate unit price in days
  // work out the actual cost by multiplying by the requiredAmount which is in days
  const ratePrice = amount * normalizedRateUnitPrice

  return {
    rate,
    price: ratePrice,
    rateUnitPrice,
    rateTotalPrice,
    matching: amount >= rateThreshold, 
  }
}

// from the given rates that have passed the threshold
// return the one with the cheapest price
const getRateWithCheapestPrice = (rates) => {
  return rates.reduce((cheapest, current) => {
    return !cheapest || current.price < cheapest.price ?
      current :
      cheapest
  }, null)
}

// if we have no rates that match the required threshold
// we should pick the rate with the highest price
// we should never give a better price because
// the required amount is too small to match
const getRateWithHighestPrice = (rates) => {
  return rates.reduce((highest, current) => {
    return !highest || current.price > highest.price ?
      current :
      highest
  }, null)
}

// get the lowest rate for the amount of time asked for
const getCheapestRate = ({
  resource,
  amount,
  unit,
  overrides,
  ignoreRates,
}) => {

  const isTimeBased = info.isTimeBased(resource)
  const baseRate = info.baseRate(resource)
  const rates = info.rates(resource)

  const allRates = baseRate ?
    [baseRate].concat(rates) :
    rates

  // get the normalize to days coefficient for the required amount
  // for week - this would be 5
  // for hour - this would be 1/8
  // for day - this would be 1
  const requiredAmountCoefficient = isTimeBased ?
    info.getTimeUnitDays(unit) :
    1

  // the amount we required normalized to days
  // amount = 2, unit = week, coeff = 5, requiredAmount = 10
  // amount = 8, unit = hour, coeff = 1/8, requiredAmount = 1
  // amount = 3, unit = day, coeff = 1, requiredAmount = 3
  const requiredAmount = requiredAmountCoefficient * amount

  const processedRates = allRates
    .map(rate => {
      return getRatePrice({
        rate,
        isTimeBased,
        amount: requiredAmount,
      })
    })

  const matchingRates = processedRates.filter(rate => rate.matching)

  let useRate = matchingRates.length > 0 ?
    getRateWithCheapestPrice(matchingRates) :
    getRateWithHighestPrice(processedRates)

  if(ignoreRates) {
    useRate = getRateWithHighestPrice(processedRates)
  }

  if(overrides && overrides.price) {
    useRate = Object.assign({}, useRate, {
      price: overrides.price * amount,
      rateUnitPrice: overrides.price,
      rateTotalPrice: overrides.price,
    })

    useRate.rate = Object.assign({}, useRate.rate, {
      price: overrides.price,
    })
  }

  return useRate
}

module.exports = {
  getRatePrice,
  getCheapestRate,
}